import { render, staticRenderFns } from "./display-groups.vue?vue&type=template&id=341a4cf3&scoped=true&"
import script from "./display-groups.vue?vue&type=script&lang=js&"
export * from "./display-groups.vue?vue&type=script&lang=js&"
import style0 from "./display-groups.vue?vue&type=style&index=0&id=341a4cf3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "341a4cf3",
  null
  
)

export default component.exports